export const EVENT_TYPES = {
  PAGE: 'page',
  TRACK: 'track',
  IDENTIFY: 'identify',
}
